import React from "react";
import Card from "react-bootstrap/Card";

export default class IndexScoringQueue extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { pendingTranscripts, availableTranscripts, currentContractor } =
      this.props;

    return (
      <Card body>
        <h1 className="large">Review calls</h1>

        {pendingTranscripts.length > 0 &&
          pendingTranscripts.map((call) => (
            <ul key={call.id}>
              <li>
                <a href={"/qa/scoring/" + call.id}>
                  You haven{"'"}t finished scoring this call
                </a>
              </li>
            </ul>
          ))}

        {pendingTranscripts.length === 0 && (
          <div>
            <h1 className="large">Transcripts Available</h1>
            {availableTranscripts.length === 0 && (
              <span>No calls available, please check back soon!</span>
            )}
            {availableTranscripts.length > 0 && (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Call Id</th>
                    <th>Click to review</th>
                    <th>Call Length</th>
                    {!currentContractor.hourly && <th>Estimated Earnings</th>}
                    <th>Company</th>
                    <th>Call Type</th>
                    <th>Occurred At</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {availableTranscripts.map((call) => {
                    return (
                      <tr key={call.id}>
                        <td>{call.display_id}</td>
                        <td>
                          <a href={"/qa/scoring/" + call.id}>review call</a>
                        </td>
                        <td>
                          {(call.call_length_sec / 60).toFixed(1)} minutes
                        </td>
                        {!currentContractor.hourly && (
                          <td>${call.scoring_price.toFixed(2)}</td>
                        )}
                        <td>{call.company.name}</td>
                        <td>{call.call_type.name}</td>
                        <td>{call.occurred_at}</td>
                        <td>
                          {!call.company &&
                            !call.company.has_customer_side &&
                            "Please note that this call is a one-sided call."}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        )}
      </Card>
    );
  }
}
